module.exports = __webpack_public_path__ + "img/outside-temperature-lg.ff50e19e.svg";